import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiResponse } from '@models/ApiResponse/apiResponse';
import { TenantDto } from '@models/ApiResponse/tenant';
import { AppError } from '@models/appError';
import {
    ApiEndpointsService,
    ApiHttpErrorService,
    ApiHttpService,
    AuthenticationService,
    RouteNavigationService,
    ToastService
} from '@services/index';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  public forgotPasswordForm: FormGroup;
  public sendingEmail = false;
  public submitted = false;
  private tenant: TenantDto;

  constructor(
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private toastService: ToastService,
    private httpService: ApiHttpService,
    private endpointsService: ApiEndpointsService,
    private routeNavService: RouteNavigationService,
    private httpErrorService: ApiHttpErrorService
  ) {
    this.tenant = this.authenticationService.currentTenantValue;
  }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get email() {
    return this.forgotPasswordForm?.get('email');
  }

  public submitForgotPasswordForm() {
    this.submitted = true;

    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.sendingEmail = true;

    const emailUsed = this.email.value;

    this.httpService
      .post<ApiResponse<any>>(this.endpointsService.forgotPassword(), {
        email: emailUsed,
        tenantId: this.tenant.id,
      })
      .pipe(
        take(1),
        finalize(() => {
          this.sendingEmail = false;
        })
      )
      .subscribe(
        () => {
          this.toastService.showSuccess(
            `A reset link was sent to ${emailUsed}.\n\nPlease check your inbox for further instructions.`
          );
          this.routeNavService.login();
        },
        (error: AppError) => {
          this.httpErrorService.handle(error);
        }
      );
  }
}
